import { Instagram, Facebook, Linkedin } from "lucide-react";

export const TikTokIcon = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export const SocialIcon = ({ icon, size = 18, className = "" }) => {
  if (icon === "instagram") return <Instagram size={size} className={className} />;
  if (icon === "facebook") return <Facebook size={size} className={className} />;
  if (icon === "linkedin") return <Linkedin size={size} className={className} />;
  return <TikTokIcon size={size} className={className} />;
};

export const LogoMark = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
  >
    <rect width="64" height="64" rx="16" fill="#FDFBF7" />
    <circle cx="32" cy="27" r="11" fill="#C5A059" />
    <path
      d="M8 44 Q20 37 32 44 T56 44"
      stroke="#9CB6C4"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M14 52 Q26 47 32 52 T50 52"
      stroke="#C5A059"
      strokeWidth="3"
      strokeLinecap="round"
      opacity="0.55"
    />
  </svg>
);
